export const engravingMixin = {
  methods: {
    getEngravingLimit(engravingOptions){
      return engravingOptions?.character_limit ?? 9;
    }
  },
}
